import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/plat/admin/track/parameter/"

function baseApi() {
    function insertTrackParameter(data) {
        return Post(baseUrl + "insertTrackParameter", data)
    }

    function deleteTrackParameter(data) {
        return Post(baseUrl + "deleteTrackParameter", data)
    }

    function updateTrackParameter(data) {
        return Post(baseUrl + "updateTrackParameter", data)
    }

    function queryTrackParameter(data) {
        return Post(baseUrl + "queryTrackParameter", data)
    }

    return {
        insertTrackParameter,
        deleteTrackParameter,
        updateTrackParameter,
        queryTrackParameter
    }
}

export const trackParameterApi = baseApi()